import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogClickTodayDelivery = () => {
  const logGoodsAnalyticsEvent = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalyticsEvent({
      name: 'CLICK_TODAY_DELIVERY',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, [logGoodsAnalyticsEvent]);
};
